import { AllowedOptionRow } from '../../components/AllowedOptions/types';
import { AllowedOptionDTO } from '../../types/settings/allowedOptionsInterfaces';

export const mapRowToDTO = (row: AllowedOptionRow): AllowedOptionDTO => ({
  module: row.module,
  target: row.target,
  code: row.code,
  selected: row.selected,
  label: row.name, // ⚠️ name → label
});
